import type { TemplateOnlyComponent } from '@ember/component/template-only';

export interface Signature {
  Args: {
    class?: string;
  };
  Element: SVGElement;
}

const WrReadCommentIconComponent: TemplateOnlyComponent<Signature> = <template>
  <svg
    xmlns='http://www.w3.org/2000/svg'
    width='16'
    height='16'
    viewBox='0 0 16 16'
    fill='none'
    class={{@class}}
    ...attributes
  >
    <path
      d='M11.4 4.7C11.4 5.1 11.1 5.4 10.7 5.4H4.7C4.3 5.4 4 5.1 4 4.7C4 4.3 4.3 4 4.7 4H10.7C11.1 4 11.4 4.3 11.4 4.7ZM10.7 8H4.7C4.3 8 4 8.3 4 8.7C4 9.1 4.3 9.4 4.7 9.4H10.7C11.1 9.4 11.4 9.1 11.4 8.7C11.4 8.3 11.1 8 10.7 8ZM10.7 6H4.7C4.3 6 4 6.3 4 6.7C4 7.1 4.3 7.4 4.7 7.4H10.7C11.1 7.4 11.4 7.1 11.4 6.7C11.4 6.3 11.1 6 10.7 6ZM15.4 2.8V10.8C15.4 11.8 14.6 12.6 13.6 12.6H5.3L3.1 14.8C2 15.9 0 15.1 0 13.5V2.8C0 1.8 0.8 1 1.8 1H13.6C14.6 1 15.4 1.8 15.4 2.8ZM14 2.8C14 2.6 13.8 2.4 13.6 2.4H1.8C1.6 2.4 1.4 2.6 1.4 2.8V13.5C1.4 13.9 1.8 14 2.1 13.8L4.5 11.4C4.6 11.3 4.8 11.2 5 11.2H13.6C13.8 11.2 14 11 14 10.8V2.8Z'
      fill='currentColor'
    />
  </svg>
</template>;

export default WrReadCommentIconComponent;
